import { ToggleContentManager } from "./actions/ToggleContentManager.js";

ToggleContentManager.use();
